<template>
  <div style="height: 100%" class="bom">
    <SplitContainer3 style="height:100%" :layout="12" :split_setting1="0.4">
      <template #main>
        <TableMain name="one table" ref="CostCaclTable1" :fields="fields1" :title="'quote_apply_detail'"
          :date_picker_label="''" :query_button_label="query_lable" :show_query_container="true"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false"
          :show_toolbar_state="false" :show_filter="true" :isBusy="isBusy" :show_query_button="false"
          :table_height_adjust="-6" :show_toolbar_button="[0, 0, 0, 0, 0]" :loading_width="60"
          :hb_table_class="'hb_table_costcacledit_class1'" @current_changed="current_changed" tableref="357eeffcb82542a086160f3a123e53d7">
          <template #query>
            <el-form ref="dataForm" label-width="120px" class="mt-1 pl-4">
              <el-col :span="24">
                <el-form-item label="报价申请编号：" class="mb-0">
                  <el-select size="mini" v-model="QuotationTaskNum" filterable remote reserve-keyword
                    :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')" @focus="QTRemoteMethod('')"
                    placeholder="请输入报价申请编号关键词" style="width:200px">
                    <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户名称：" class="mb-0">
                  <el-input placeholder="请输入客户名称" v-model="CustName" style="width:200px" clearable
                    class="mr-1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物料编号：" class="mb-0">
                  <el-input placeholder="请输入物料编号" v-model="ItemId" style="width:200px" clearable class="mr-1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="物料名称：" class="mb-0">
                  <el-input placeholder="请输入物料名称" v-model="NameAlias" style="width:200px" clearable
                    @input="onInput()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="float:right">
                <el-form-item class="mb-0">
                  <el-button type="primary" @click="on_query"><i
                      class="iconfont icon-search"></i>&nbsp;&nbsp;{{ $t('common.query') }}
                  </el-button>
                </el-form-item>
              </el-col>
            </el-form>

          </template>
        </TableMain>
      </template>
      <template #top>
        <TableMain ref="CostCaclTable2" :fields="detail_cacl_fields" :show_query_container="false"
          :title="'quote_apply_detail_company'" :show_toolbar="false" :show_toolbar_state="false" :date_picker_label="''"
          :table_height_adjust="8" :check_state="true" :show_pagination="true" :show_filter="false" :pager_count="5"
          :isBusy="isBusy2" :show_toolbar_button="[0, 0, 0, 0, 0]" tableref="e15b7ac3fd1446e7b239ca5ee6ac6839">
          <template #operation>
            <el-button type="danger" @click="caclCost"><i class="iconfont icon-system"></i>&nbsp;&nbsp;计算
            </el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="CostCaclTable3" :fields="detail_cost_fields" :show_query_container="false"
          :title="'quote_apply_detail_company_cost'" :show_toolbar="false" :show_toolbar_state="false"
          :date_picker_label="''" :table_height_adjust="2" :check_state="true" :show_pagination="true"
          :show_filter="false" :pager_count="5" :isBusy="isBusy3" :show_toolbar_button="[0, 0, 0, 0, 0]"
          @on_cell_button_click="on_cell_button_click" tableref="f858ea4287db4978b1f81402e3f96a60">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="Detail_SaveData"
              :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer3>
    <el-drawer :size="'70%'" :visible.sync="isShowDrawer" :direction="'rtl'" :modal="false">
      <template slot="title">
        <span>{{ DrawerTitle }}</span>
      </template>
      <CostTree :data1="treeData1" :data2="treeData2" :data3="treeData3" :total_cost="total_cost"
        :cur_product_qty="cur_product_qty" :dataAreaId="dataAreaId"></CostTree>
    </el-drawer>
  </div>
</template>

<script>
import * as CostItemsController from "../../controllers/sd/CostItemsController";
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController";
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController";
import QueryButton from "../components/base/QueryButton";
import SplitContainer3 from "../components/container/SplitContainer3";
import TableMain from "../components/table/TableMain";
import CostTree from "./CostTree.vue";
export default {
  components: {
    SplitContainer3,
    TableMain,
    QueryButton,
    CostTree
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      fields1: _.cloneDeep(CostItemsController.fields.qt_detail),
      detail_cacl_fields: CostItemsController.fields.detail_cacl_fields,
      detail_cost_fields: CostItemsController.fields.detail_cost_fields,
      QuotationTaskNum: "",
      CustName: "",
      ItemId: "",
      NameAlias: "",
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      activeCode: "bomcost",
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      total_cost: 0,
      cur_product_qty: 1,
      DrawerTitle: "",
      isShowDrawer: false,
      dataAreaId: "",
      treeData1: [],
      treeData2: [],
      treeData3: [],
      QTOptions: [],
    }
  },
  created() { },
  mounted() { },
  methods: {
    ///获取报价申请编号
    async getKvQuoteTask(query = '') {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "kv");
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum };
        });
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      await this.getKvQuoteTask(query);
    },
    async on_query() {
      this.QuotationTaskNum = _.trim(this.QuotationTaskNum);
      this.$refs.CostCaclTable1.SetData([]);
      this.$refs.CostCaclTable2.SetData([]);
      this.$refs.CostCaclTable3.SetData([]);
      // if (this.QuotationTaskNum == "") {
      //   this.msgToasts("请输入报价申请编号！", "info");
      //   return;
      // }
      this.isBusy = true;
      let p = {
        QuotationTaskNum: this.QuotationTaskNum,
        CustName: "%" + this.CustName + "%",
        ItemId: this.ItemId,
        NameAlias: "%" + this.NameAlias + "%",
      }
      let _result = await QuotationTaskController.methods.getDetailDataBySql(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (_result[0].length == 0)
          this.msgToasts("查询未果原因：未处理完成或者是纯外协申请！", "info");
        else
          this.$refs.CostCaclTable1.SetData(_.orderBy(_result[0], ["QuotationTaskNum", "LineNum"], ["desc", "asc"]));
      }

      this.isBusy = false;
    },
    current_changed(old, current) {
      if (current) {
        this.isBusy2 = true;
        let dt = []
        let BomData = [], RouteData = [], TransportData = [];
        if (current.BomID && current.BomID != "") {
          BomData = JSON.parse(current.BomID);
        }
        if (current.RouteID && current.RouteID != "") {
          RouteData = JSON.parse(current.RouteID);
        }
        if (current.TransportCost && current.TransportCost != "") {
          TransportData = JSON.parse(current.TransportCost);
        }
        _.each(BomData, (t) => {
          let m = _.find(dt, { AccountNum: t.AccountNum })
          if (m)
            m["BomID"] = t.BomID
          else
            dt.push(t);
        })
        _.each(RouteData, (t) => {
          let m = _.find(dt, { AccountNum: t.AccountNum })
          if (m)
            m["RouteID"] = t.RouteID
          else
            dt.push(t);
        })
        _.each(TransportData, (t) => {
          console.log(t)
          t.TransportCost = parseFloat(t.TransportCost)
          let m = _.find(dt, { AccountNum: t.AccountNum })
          if (m) {
            if (!m["TransportCost"])
              m["TransportCost"] = 0

            m["TransportCost"] += t.TransportCost
          }
          else
            dt.push(t);
        })
        this.$refs.CostCaclTable2.SetData(dt);
        this.getDetailCost();
        this.isBusy2 = false;
      }
    },
    ///计算
    async caclCost() {
      let selected_items = this.$refs.CostCaclTable2.my_data;
      if (selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.CaclResultData = [];
      let task_cur_item = this.$refs.CostCaclTable1.GetCurrentItem();
      for (var i in selected_items) {
        let _dataAreadId_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: selected_items[i].AccountNum });
        let _dataAreadId = "";
        if (_dataAreadId_m)
          _dataAreadId = _dataAreadId_m.DataArea;

        let p = {
          ItemId: task_cur_item.ItemId,
          ProductQty: task_cur_item.BatchQty,
          AccountNum: selected_items[i].AccountNum,
          AccountName: selected_items[i].AccountName,
          TransportCost: selected_items[i].TransportCost,
          dataAreaId: _dataAreadId,
          BomID: selected_items[i].BomID,
          RouteID: selected_items[i].RouteID,
          QuotationTaskDetailId: task_cur_item.id
        }
        await this.on_query_bom(p);
      }
      let dt = _.map(this.CaclResultData, (t) => {
        t.TotalCost = _.round(t.total_cost, 6);
        t.TotalAllCost = _.round((t.TotalCost + (t.TransportCost ? t.TransportCost : 0)), 6);
        t.PerCost = _.round(t.TotalAllCost / t.ProductQty, 6);
        return t
      })
      this.$refs.CostCaclTable3.SetData(dt);
      loading.close();
    },

    async on_query_bom(p) {
      let _rt1 = await InventBomVersionController.methods.getDataBySql({ SearchText: p.ItemId, Active: 1 });
      if (!_.isNull(_rt1) && _rt1 && _rt1.length > 0 && _rt1[0].length > 0) {
        let _rt2 = await CostItemsController.methods.execCalcBomCost(p);
        let _rt3 = await CostItemsController.methods.execCalcRsrcCost(p);
        let cm = {
          id: "",
          InventNum: p.ItemId,
          ProductQty: p.ProductQty,
          AccountNum: p.AccountNum,
          AccountName: p.AccountName,
          CaclRouteData: _rt1[0][0],//工艺路线计算原始数据
          CaclBomCostData: _rt2,//bom成本额计算原始数据
          CalcRsrcCostData: _rt3,//资源成本计算原始数据
          BomCostData: [],//bom成本额tree数据
          WrkCtrCostData: [],//资源成本tree数据
          CostGroupData: [],//成本组tree数据
          TransportCost: p.TransportCost,//运输成本
          total_cost: 0 //总成本
        }
        this.calcBomCost(cm) //成本额
        this.calcWrkCtrCost(cm) //资源成本
        this.calcCostGroup(cm) //成本组
        this.CaclResultData.push(cm)
      }
      console.log(this.CaclResultData)
    },

    //#region 整理BOM成本额tree
    calcBomCost(p) {
      let mm = p.CaclRouteData, dt = p.CaclBomCostData;
      let mt = {
        label: mm.ItemId + "：" + mm.Name,
        ItemId: mm.ItemId,
        purch_price: mm.InventPrice * p.ProductQty,
        invent_cost: 0,
        real_qty: parseFloat(p.ProductQty),
        product_qty: parseFloat(p.ProductQty),
        DW_InventUnitId: "个",
        TEC_SpoilageType: "无",
        children: []
      }
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let md = _.find(dt[0], { DetailItemId: p.InventNum })
        if (md) {
          mt.invent_cost = md.invent_cost
          p.total_cost += md.invent_cost;
        }
        this.buildTreeBomCost(dt[0], p.InventNum, mt)
      }
      p.BomCostData.push(mt);
    },
    buildTreeBomCost(dt, ItemId, rt) {
      for (var i in dt) {
        let t = dt[i];
        let mt = {
          label: "【" + t.OprId + "】" + t.DetailItemId + "：" + t.NameAlias,
          ItemId: t.DetailItemId,
          purch_price: t.purch_price ? t.purch_price : 0,
          invent_cost: t.invent_cost ? t.invent_cost : 0,
          real_qty: t.real_qty,
          product_qty: parseFloat(rt.product_qty),
          DW_InventUnitId: t.DW_InventUnitId,
          TEC_SpoilageType: t.TEC_SpoilageType,
          children: []
        }
        if (t.ItemId == ItemId) {
          this.buildTreeBomCost(dt, mt.ItemId, mt)
          rt.children.push(mt);
        }
      }
    },
    //#endregion

    //#region 整理资源tree
    calcWrkCtrCost(p) {
      let dt = p.CalcRsrcCostData, cost_dt = [], order_cost_dt = [];
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let group_rsrc = _.groupBy(dt[0], "ItemId");
        let _seq = 1
        for (var k in group_rsrc) {
          if (k != "undefined") {
            let mt = {
              label: k,
              Electricity: 0,
              LaborCost: 0,
              AccountNum: p.AccountNum,
              InventNum: p.InventNum,
              seq: _seq,
              children: []
            }
            let children = _.uniqBy(group_rsrc[k], "OprNum");
            this.buildTreeWrkCtrCost(children, k, mt);
            cost_dt.push(mt);
            _seq += 1;
          }
        }
        //调整顺序

        _.each(cost_dt, (t) => {
          let pItem = _.find(p.CaclBomCostData[0], { DetailItemId: t.ItemId });
          let fd = _.find(cost_dt, { ItemId: pItem.ItemId });
          if (fd) {
            fd.Electricity += t.Electricity;
            fd.LaborCost += t.LaborCost;
            fd.children.push(t)
          }
          else {
            order_cost_dt.push(t);
          }
        })
      }
      if (order_cost_dt.length > 0) {
        p.total_cost += order_cost_dt[0].Electricity;
        p.total_cost += order_cost_dt[0].LaborCost;
        p.WrkCtrCostData = order_cost_dt;
      }
    },
    buildTreeWrkCtrCost(dt, ItemId, rt) {
      let _Electricity = 0, _LaborCost = 0;
      let filter_dt = _.orderBy(dt, ["OprNum"], ["asc"]);
      for (var i in filter_dt) {
        let t = filter_dt[i];
        let _label = t.OprNum + "：" + t.OprId;
        let mt = {
          label: _label,
          Electricity: t.Electricity ? t.Electricity : 0,
          LaborCost: t.LaborCost ? t.LaborCost : 0,
          WrkCtrId: t.WrkCtrId,
          RealQty: t.RealQty ? t.RealQty : "",
          UPH: t.UPH ? t.UPH : 1,
          SetupTime: t.SetupTime ? t.SetupTime : 0,
          SEI_WorkerCount: t.SEI_WorkerCount ? t.SEI_WorkerCount : 0,
          TEC_EquipPower: t.TEC_EquipPower ? t.TEC_EquipPower : 0,
          cPerWorkerPrice: t.cPerWorkerPrice ? t.cPerWorkerPrice : 0,
          PerWorkerPrice: t.PerWorkerPrice ? t.PerWorkerPrice : 0,
          children: []
        }
        _Electricity += mt.Electricity
        _LaborCost += mt.LaborCost
        rt.children.push(mt);
      }
      rt.label = ItemId + "：" + dt[0].NameAlias
      rt.Electricity = _Electricity;
      rt.LaborCost = _LaborCost;
      rt.ItemId = ItemId;
      rt.id = ItemId;
      if (ItemId == rt.InventNum) {
        rt.id = "r1";
        rt.seq = 0;
      }
    },
    //#endregion

    //#region 整理成本组tree
    calcCostGroup(p) {
      let mm = p.CaclRouteData, dt = p.CaclBomCostData;
      let mt = {
        id: 1,
        label: mm.ItemId + "：" + mm.Name,
        ItemId: mm.ItemId,
        invent_cost: 0,
        real_qty: parseFloat(p.ProductQty),
        price: 0,
        children: []
      }
      if (!_.isNull(dt) && dt && dt.length > 0) {
        let md = _.find(dt[0], { DetailItemId: p.ItemId })
        if (md) {
          mt.invent_cost = md.invent_cost
        }
        this.buildTreeCostGroup(dt[0], p.ItemId, mt)
      }
      let group_cost_group = _.groupBy(mt.children, "CostGroupId");
      let cost_children_dt = [];

      for (var k in group_cost_group) {
        let sum_price = _.sumBy(group_cost_group[k], (t) => {
          return t.invent_cost / parseFloat(p.ProductQty)
        })
        let cost_children_invent_dt = _.map(group_cost_group[k], (t) => {
          return {
            label: t.label,
            price: t.invent_cost / parseFloat(p.ProductQty)
          }
        });
        let m = {
          label: k,
          price: sum_price,
          children: cost_children_invent_dt
        }
        cost_children_dt.push(m);
      }
      mt.children = cost_children_dt;

      ///增加人工成本和电费
      let total_Electricity = 0, total_LaborCost = 0;
      if (p.WrkCtrCostData.length > 0) {
        total_Electricity = p.WrkCtrCostData[0].Electricity;
        total_LaborCost = p.WrkCtrCostData[0].LaborCost;
      }
      //人工费
      let lc = {
        id: 20,
        label: "O11人工费",
        LaborCost: total_LaborCost,
        price: total_LaborCost / parseFloat(p.ProductQty),
        cost_type: "O11",
        children: []
      }
      let el_dt1 = _.cloneDeep(p.WrkCtrCostData);
      if (el_dt1.length > 0) {
        this.changeCostType(el_dt1, "O11");
        lc.children = _.cloneDeep(el_dt1)[0].children;
        _.remove(el_dt1, (t) => { return t.id == "r1" });
        lc.children = _.unionWith(lc.children, el_dt1);
        mt.children.push(lc);
      }
      //电费
      let ep = {
        id: 21,
        label: "O23电费",
        Electricity: total_Electricity,
        price: total_Electricity / parseFloat(p.ProductQty),
        cost_type: "O23",
        children: []
      }
      let el_dt2 = _.cloneDeep(p.WrkCtrCostData);
      if (el_dt2.length > 0) {
        this.changeCostType(el_dt2, "O23");
        ep.children = _.cloneDeep(el_dt2)[0].children;
        _.remove(el_dt2, (t) => { return t.id == "r1" });
        ep.children = _.unionWith(ep.children, el_dt2);
        mt.children.push(ep);
      }
      // //运输成本
      // let tt = {
      //   id: 22,
      //   label: "运输成本",
      //   TransportCost: this.TransportCost,
      //   cost_type: "O24",
      //   children: []
      // }
      // mt.children.push(tt);
      mt.price = _.sumBy(mt.children, (t) => {
        return t.price
      });
      p.CostGroupData.push(mt);
    },
    changeCostType(dt, cost_type) {
      for (var k in dt) {
        let t = dt[k]
        t.cost_type = cost_type;
        if (t.children.length > 0) {
          this.changeCostType(t.children, cost_type);
        }
      }
    },
    buildTreeCostGroup(dt, ItemId, rt) {
      for (var i in dt) {
        let t = dt[i];
        let mt = {
          label: t.DetailItemId + "：" + t.NameAlias,
          ItemId: t.ItemId,
          invent_cost: t.invent_cost ? t.invent_cost : 0,
          real_qty: t.real_qty ? t.real_qty : 1,
          CostGroupId: t.CostGroupId,
          children: []
        }
        if (t.ItemId == ItemId) {
          this.buildTreeCostGroup(dt, t.DetailItemId, rt);
          if (t.has_children == 0)
            rt.children.push(mt);
        }
      }
    },
    //#endregion

    //#region 计算明细相关
    async getDetailCost(isLoading = true) {
      let current = this.$refs.CostCaclTable1.GetCurrentItem();
      if (!current) {
        return;
      }
      if (isLoading) {
        this.isBusy3 = true;
        this.$refs.CostCaclTable3.SetData([]);
      }
      let p = { QuotationTaskDetailId: { "=": current.id } };
      let _result = await CostItemsController.methods.getDataDetailCost(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.each(_.orderBy(_result[0], ["id"], ["asc"]), (t) => {
          // t.TotalAllCost = t.TotalCost + t.TransportCost;
          this.transToContext(t);
        })
        this.$refs.CostCaclTable3.SetData(dt);
      }
      this.isBusy3 = false;
    },
    async Detail_SaveData(cb) {
      let current = this.$refs.CostCaclTable1.GetCurrentItem();
      let dt = _.cloneDeep(this.$refs.CostCaclTable3.my_data);
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }

      //数据验证
      _.each(dt, (t) => {
        for (var k in t) {
          if (k.startsWith("_")) {
            delete t[k]
          }
        }
        t.QuotationTaskDetailId = current.id;
        t.QuotationTaskId = current.QuotationTaskId;
        t.QuotationTaskNum = current.QuotationTaskNum;
        t.ItemId = current.ItemId;
        t.NameAlias = current.NameAlias;

        this.transToContext(t, 0);

        delete t.InventNum;
        delete t.CostDetail;
        delete t.total_cost;
      })
      console.log(dt);
      let p = {};
      p.add = _.map(_.filter(dt, { id: "" }), (t) => { delete t.id; return t });
      p.edit = _.filter(dt, (t) => { return t.id && t.id != "" });

      let rt = await CostItemsController.methods.saveDataDetailCost(p);
      if (rt) {
        await this.getDetailCost(false);
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true, true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    on_cell_button_click(data) {

      this.DrawerTitle = "供应商：" + data.item.AccountName + "，制造成本：" + data.item.TotalCost;
      this.treeData1 = data.item.BomCostData;
      this.treeData2 = data.item.WrkCtrCostData;
      this.treeData3 = data.item.CostGroupData;
      this.total_cost = data.item.TotalCost;
      this.cur_product_qty = data.item.ProductQty;
      this.dataAreaId = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { VenderAccountNum: data.item.AccountNum }).DataArea;
      this.isShowDrawer = true;
    },
    transToContext(t, type) {
      if (type == 0) {
        t.BomCostData = JSON.stringify(t.BomCostData);
        t.CaclBomCostData = JSON.stringify(t.CaclBomCostData);
        t.CaclRouteData = JSON.stringify(t.CaclRouteData);
        t.CalcRsrcCostData = JSON.stringify(t.CalcRsrcCostData);
        t.CostGroupData = JSON.stringify(t.CostGroupData);
        t.WrkCtrCostData = JSON.stringify(t.WrkCtrCostData);
      }
      else {
        t.BomCostData = JSON.parse(t.BomCostData);
        t.CaclBomCostData = JSON.parse(t.CaclBomCostData);
        t.CaclRouteData = JSON.parse(t.CaclRouteData);
        t.CalcRsrcCostData = JSON.parse(t.CalcRsrcCostData);
        t.CostGroupData = JSON.parse(t.CostGroupData);
        t.WrkCtrCostData = JSON.parse(t.WrkCtrCostData);
      }
    },
    //#endregion
  },
}
</script>
<style >
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

/* .el-tree-node__content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 26px;
  cursor: no-drop;
} */
.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #1138e1b3;
  color: #fff;
}

.hb_table_costcacledit_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 105rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
}</style>

